/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_EmptyInputs */

const cs_messages_empty = /** @type {(inputs: Messages_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V této dlaždici zatím žádné zprávy.`)
};

const en_messages_empty = /** @type {(inputs: Messages_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No messages in this tile yet.`)
};

/**
* | output |
* | --- |
* | "No messages in this tile yet." |
*
* @param {Messages_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_empty = /** @type {((inputs?: Messages_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_empty(inputs)
	return cs_messages_empty(inputs)
});